import { API_URL } from "../../config/Config";
import axios from "axios";
import axiosRetry from "axios-retry";

axiosRetry(axios, { retries: 3 });

export async function urlGet(url) {
  try {
    let response = await axios.get(`${API_URL}${url}`);
    return response.status >= 200 && response.status < 300
      ? response.data.data || []
      : null;
  } catch (e) {
    console.log(e);
  }
}
export async function getData(url) {
  try {
    let response = await axios.get(`${API_URL}${url}`);
    return {
      data: response.status === 200 ? response.data : null,
      loading: true,
      error: false,
    };
  } catch (e) {
    console.log(e);
    return {
      data: null,
      loading: true,
      error: true,
    };
  }
}

export async function userGet(url, token = null) {
  try {
    const options = {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": "fa",
      },
    };

    if (token !== null) {
      options.headers["Authorization"] = `Bearer ${token}`;
    }

    let response = await axios.get(`${API_URL}${url}`, options);
    // console.log(response);
    if (response.status > 199 && response.status < 300) {
      return {
        data: response.data,
        error: false,
        status: response.status,
      };
    }
    return {
      data: response.data,
      error: true,
      status: response.status,
    };
  } catch (e) {
    console.log(e);
    return {
      data: null,
      error: true,
      status: e.response.status,
    };
  }
}

export async function postData(
  url,
  data,
  contentType = "application/x-www-form-urlencoded"
) {
  try {
    const options = {
      headers: {
        "content-type": contentType,
        Accept: "application/json",
        "Accept-Language": "fa",
      },
    };
    const response = await axios.post(`${API_URL}${url}`, data, options);
    if (response.status > 199 && response.status < 300) {
      return {
        data: response.data,
        loading: true,
        error: false,
        status: response.status,
      };
    }
    return {
      data: response.data,
      loading: true,
      error: true,
      status: response.status,
    };
  } catch (e) {
    console.log(e);
    return {
      data: null,
      loading: true,
      error: true,
      status: e.response.status,
    };
  }
}
export async function postDataAuth(url, data, token) {
  try {
    const options = {
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Accept: "application/json",
        "Accept-Language": "fa",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(`${API_URL}${url}`, data, options);
    if (response.status > 199 && response.status < 300) {
      return {
        data: response.data,
        loading: true,
        error: false,
        status: response.status,
      };
    }
    return {
      data: response.data,
      loading: true,
      error: true,
      status: response.status,
    };
  } catch (e) {
    console.log(e);
    return {
      data: null,
      loading: true,
      error: true,
      status: e.response.status,
    };
  }
}

export async function postDataAuthCustom(url, method, data, token = null) {
  try {
    const options = {
      method,
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        "Content-Type": "application/json",
        "Accept-Language": "fa",
      },
      data,
      url: `${API_URL}${url}`,
    };

    if (token !== null) {
      options.headers["Authorization"] = `Bearer ${token}`;
    }
    const response = await axios(options);

    if (response.status > 199 && response.status < 300) {
      return {
        data: response.data,
        error: false,
        status: response.status,
      };
    }
    return {
      data: response.data,
      error: true,
      status: response.status,
    };
  } catch (e) {
    console.log(e);
    return {
      data: null,
      error: true,
      status: e.response.status,
    };
  }
}

export async function postDataMyComplains(url, method, data, token = null) {
  try {
    const options = {
      method,
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        "Content-Type": "application/json",
        "Accept-Language": "fa",
      },
      data,
      url: `${API_URL}${url}`,
    };

    if (token !== null) {
      options.headers["Authorization"] = `Bearer ${token}`;
    }
    const response = await axios(options);

    if (response.status > 199 && response.status < 300) {
      return {
        data: response.data,
        error: false,
        status: response.status,
      };
    }
    return {
      data: response.data,
      error: true,
      status: response.status,
    };
  } catch (e) {
    console.log(e);
    return {
      data: null,
      error: true,
      status: e.response.status,
    };
  }
}

export async function objectToOption(obj) {
  return await obj.map((item) => {
    return {
      value: item.id,
      label: item.name,
      ...item,
    };
  });
}

export async function categoryWithParents(cats, id) {
  const myCatArray = [];
  let selCat = cats.filter((item) => id === item.id)[0];
  myCatArray.push(selCat);
  return recersiveCatFinder(cats, myCatArray);
}
async function recersiveCatFinder(cats, myCatArray) {
  let lastItem = myCatArray[myCatArray.length - 1];
  if (lastItem.parent !== null) {
    let selCat = cats.filter((item) => lastItem.parent.id === item.id)[0];
    myCatArray.push(selCat);
    await recersiveCatFinder(cats, myCatArray);
  } else {
    return myCatArray;
  }
}

export const filterData = (inputValue) => {
  return inputValue.filter((i) =>
    i.name.toLowerCase().includes(inputValue.toLowerCase())
  );
};

export function kpisToString(array) {
  let tempArray = [];
  for (let i = 0; i < array.length; i++) {
    let tempString = `{"id": "${array[i].id}", "name": "${array[i].name}", "rate": "${array[i].rate}" }`;
    tempArray.push(tempString);
  }
  return `[ ${tempArray.join(",")} ]`;
}
